import React from "react";

const Dropdown = ({ options, selectedOption, setSelectedOption }) => {

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };
    let classdiv = `status_table ${selectedOption}`;


  return (
    <div className= {classdiv} >
      <select
        id="statusDropdown"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {/* <p>Selected Option: {selectedOption}</p> */}
    </div>
  );
};

export default Dropdown;
